export default () => ({
  step: 1,
  visitedStep: 1,
  scanproConfiguration: null,
  scanProChecklist: [],
  scanProCriteria: [],
  isDecoded: false,
  vin: '',
  decodedVin: null,
  isSubmodelSelected: false,
  submodels: [],
  vehicle: null,
  recommendation: null,
  safety: null,
  selectedChecklistItems: []
})



// WEBPACK FOOTER //
// ./src/store/modules/scanpro/state.js